/* Blocks storefront adds of the Print A Bill $1 placeholder variants
   (52502897590548 standard, 52674499019028 RealAged) unless the line carries
   a builder stamp. Builder adds, cart edits that copy _custom_build, and
   /cart/change.js quantity updates are left alone. */
(function () {
  if (window.__pabPlaceholderGuard) return;
  window.__pabPlaceholderGuard = true;

  var VARIANT = {
    '52502897590548': true,
    '52674499019028': true
  };
  var BUILDER = '/pages/print-a-bill';

  function pathOf(input) {
    try {
      if (!input) return '';
      var raw = input;
      if (typeof Request !== 'undefined' && input instanceof Request) raw = input.url;
      else if (input instanceof URL) raw = input.href;
      return new URL(String(raw), window.location.origin).pathname;
    } catch (e) {
      return '';
    }
  }

  function isAddPath(path) {
    return path === '/cart/add' || path === '/cart/add.js';
  }

  function builderOk(props) {
    if (!props || typeof props !== 'object') return false;
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        var row = props[i];
        if (!row) continue;
        var name = row.name != null ? row.name : row[0];
        var value = row.value != null ? row.value : row[1];
        if (String(name) === '_custom_build' && String(value) === 'true') return true;
      }
      return false;
    }
    return String(props._custom_build) === 'true';
  }

  function lineBlocked(line) {
    if (!line || typeof line !== 'object') return false;
    var id = line.id != null ? line.id : line.variant_id;
    if (id == null || !VARIANT[String(id)]) return false;
    return !builderOk(line.properties);
  }

  function payloadBlocked(data) {
    if (!data || typeof data !== 'object') return false;
    if (Array.isArray(data.items)) {
      for (var i = 0; i < data.items.length; i++) {
        if (lineBlocked(data.items[i])) return true;
      }
      return false;
    }
    return lineBlocked(data);
  }

  function paramsBlocked(params) {
    var blocked = false;
    var sawIndexed = false;
    params.forEach(function (value, key) {
      var indexed = key.match(/^items\[(\d+)\]\[id\]$/);
      if (indexed) {
        sawIndexed = true;
        if (VARIANT[String(value)]) {
          var flag = params.get('items[' + indexed[1] + '][properties][_custom_build]');
          if (String(flag) !== 'true') blocked = true;
        }
      }
    });
    if (sawIndexed) return blocked;
    var id = params.get('id');
    if (!VARIANT[String(id || '')]) return false;
    return String(params.get('properties[_custom_build]')) !== 'true';
  }

  function formDataBlocked(fd) {
    var params = new URLSearchParams();
    fd.forEach(function (value, key) {
      if (typeof value === 'string') params.append(key, value);
    });
    return paramsBlocked(params);
  }

  function bodyBlocked(body) {
    if (body == null) return false;
    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (!trimmed) return false;
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try { return payloadBlocked(JSON.parse(trimmed)); } catch (e) { return false; }
      }
      try { return paramsBlocked(new URLSearchParams(trimmed)); } catch (e2) { return false; }
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return paramsBlocked(body);
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return formDataBlocked(body);
    }
    return false;
  }

  function denyResponse() {
    return new Response(JSON.stringify({
      status: 422,
      message: 'Create this bill on the Print A Bill page.',
      description: 'Create this bill on the Print A Bill page.'
    }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  if (origFetch) {
    window.fetch = function (input, init) {
      try {
        var path = pathOf(typeof input === 'string' || input instanceof URL ? input : input);
        var method = (init && init.method) || (input && input.method) || 'GET';
        if (isAddPath(path) && String(method).toUpperCase() === 'POST') {
          var body = init && Object.prototype.hasOwnProperty.call(init, 'body') ? init.body : null;
          if (bodyBlocked(body)) return Promise.resolve(denyResponse());
        }
      } catch (e) {}
      return origFetch.apply(window, arguments);
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__pabMethod = method;
    this.__pabUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (String(this.__pabMethod || '').toUpperCase() === 'POST' &&
          isAddPath(pathOf(this.__pabUrl)) &&
          bodyBlocked(body)) {
        window.location.assign(BUILDER);
        return;
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || form.action || '';
      if (!isAddPath(pathOf(action))) return;
      if (!formDataBlocked(new FormData(form))) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(BUILDER);
    } catch (e) {}
  }, true);

  function onProductPage() {
    try {
      return /\/products\/print-a-bill-custom-build\/?$/.test(window.location.pathname);
    } catch (e) {
      return false;
    }
  }

  function sweep() {
    if (!origFetch || onProductPage()) return;
    origFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response && response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        var bad = [];
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (item && VARIANT[String(item.variant_id)] && !builderOk(item.properties)) bad.push(item);
        }
        if (!bad.length) return null;
        var chain = Promise.resolve();
        bad.forEach(function (item) {
          chain = chain.then(function () {
            return origFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          });
        });
        return chain.then(function () { return true; });
      })
      .then(function (removed) {
        if (removed) window.location.reload();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

})();
